module.exports = __webpack_public_path__ + "static/media/a15.a56ffb60.jpg";